import axiosInstance from "../axiosInstance";

// Get all unread employee notifications
export const fetchEmployeeNotifications = async () => {
  const res = await axiosInstance.get("/employee/notification/all");
  return res.data.data;
};

// Get unread notification count
export const fetchEmployeeUnreadCount = async () => {
  const res = await axiosInstance.get("/employee/notification/unread-count");
  return res.data.data;
};

// Mark a single notification as read
export const markEmployeeNotificationAsRead = async (id) => {
  const res = await axiosInstance.put(`/employee/notification/${id}/read`);
  return res.data.data;
};

// Mark all notifications as read
export const markAllEmployeeNotificationsAsRead = async () => {
  const res = await axiosInstance.put("/employee/notification/mark-all-read");
  return res.data.data;
};

// Get last 7 days notifications
export const fetchLast7DaysEmployeeNotifications = async () => {
  const res = await axiosInstance.get("/employee/notification/last7days");
  return res.data.data;
};

// Save notification (Optional)
export const saveEmployeeNotification = async (payload) => {
  const res = await axiosInstance.post("/employee/notification/save", payload);
  return res.data;
};

// Test endpoint (Optional)
export const testEmployeeNotification = async () => {
  const res = await axiosInstance.get("/employee/notification/test");
  return res.data;
};

// Fetch Employee Activity Feed
export const fetchEmployeeActivityFeed = async () => {
  const res = await axiosInstance.get("/employee/activity/feed");
  return res.data;
};
